import { OptionsType } from "./stylingConfig";

export type OptionsData = {
  [key: string]: Array<OptionsType>;
};

const CmHeightOptions: OptionsData = {
  women: [
    {
      key: "0",
      value: "",
      lid: "text_styling_book_staff_customer_filter_all"
    },
    {
      key: "001150",
      value: "001150",
      max: "150",
      lid: "text_styling_book_filter_height_under"
    },
    {
      key: "150155",
      value: "150155",
      min: "150",
      max: "155"
    },
    {
      key: "155160",
      value: "155160",
      min: "155",
      max: "160"
    },
    {
      key: "160165",
      value: "160165",
      min: "160",
      max: "165"
    },
    {
      key: "165170",
      value: "165170",
      min: "165",
      max: "170"
    },
    {
      key: "170175",
      value: "170175",
      min: "170",
      max: "175"
    },
    {
      key: "175300",
      value: "175300",
      min: "175",
      lid: "text_styling_book_filter_height_over"
    }
  ],
  men: [
    {
      key: "0",
      value: "",
      lid: "text_styling_book_staff_customer_filter_all"
    },
    {
      key: "001160",
      value: "001160",
      max: "160",
      lid: "text_styling_book_filter_height_under"
    },
    {
      key: "160165",
      value: "160165",
      min: "160",
      max: "165"
    },
    {
      key: "165170",
      value: "165170",
      min: "165",
      max: "170"
    },
    {
      key: "170175",
      value: "170175",
      min: "170",
      max: "175"
    },
    {
      key: "175180",
      value: "175180",
      min: "175",
      max: "180"
    },
    {
      key: "180185",
      value: "180185",
      min: "180",
      max: "185"
    },
    {
      key: "185300",
      value: "185300",
      min: "185",
      lid: "text_styling_book_filter_height_over"
    }
  ],
  kids: [
    {
      key: "0",
      value: "",
      lid: "text_styling_book_staff_customer_filter_all"
    },
    {
      key: "001100",
      value: "001100",
      max: "100",
      lid: "text_styling_book_filter_height_under"
    },
    {
      key: "100110",
      value: "100110",
      min: "100",
      max: "110"
    },
    {
      key: "110120",
      value: "110120",
      min: "110",
      max: "120"
    },
    {
      key: "120130",
      value: "120130",
      min: "120",
      max: "130"
    },
    {
      key: "130140",
      value: "130140",
      min: "130",
      max: "140"
    },
    {
      key: "140150",
      value: "140150",
      min: "140",
      max: "150"
    },
    {
      key: "150160",
      value: "150160",
      min: "150",
      max: "160"
    },
    {
      key: "160300",
      value: "160300",
      min: "160",
      lid: "text_styling_book_filter_height_over"
    }
  ],
  baby: [
    {
      key: "0",
      value: "",
      lid: "text_styling_book_staff_customer_filter_all"
    },
    {
      key: "6070",
      value: "6070",
      min: "60",
      max: "70"
    },
    {
      key: "7080",
      value: "7080",
      min: "70",
      max: "80"
    },
    {
      key: "8090",
      value: "8090",
      min: "80",
      max: "90"
    },
    {
      key: "90100",
      value: "90100",
      min: "90",
      max: "100"
    },
    {
      key: "100110",
      value: "100110",
      min: "100",
      max: "110"
    },
    {
      key: "110300",
      value: "110300",
      min: "110",
      lid: "text_styling_book_filter_height_over"
    }
  ]
};

export const HeightOptions: { [key: string]: OptionsData } = {
  zh_HK: { ...CmHeightOptions },
  zh_TW: { ...CmHeightOptions },
  en_GB: { ...CmHeightOptions }
};
